<ms-wallet-selection-dropdown
    [ngClass]="{ 'in-column-wallet': inColumn }"
    [trackingPosition]="trackingPosition"
    [inColumn]="inColumn"
    [showExtendedInfo]="showExtendedInfo"
    [singleWallet]="singleWallet"
    [bottomOptions]="bottomOptions"
    (expandWalletDropDown)="onExpandWalletDropDown($event)"
    (openPayPalHelp)="onOpenPayPalHelp($event)" />
